import { usePermissions } from './usePermissions'

export function useMaterialPermissions() {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions()
  
  // Specific Materials permission checks
  const canViewMaterials = () => hasAnyPermission(['Supplier.Materials'])
  const canCreateMaterials = () => hasAnyPermission(['Supplier.Materials.Create'])
  const canEditMaterials = () => hasAnyPermission(['Supplier.Materials.Edit'])
  const canDeleteMaterials = () => hasAnyPermission(['Supplier.Materials.Delete'])
  
  // Combined permission checks
  const canAccessMaterials = () => hasAnyPermission([
    'Supplier.Materials',
    'Supplier.Materials.Create',
    'Supplier.Materials.Edit',
    'Supplier.Materials.Delete'
  ])
  
  const canManageMaterials = () => hasAnyPermission([
    'Supplier.Materials.Create',
    'Supplier.Materials.Edit',
    'Supplier.Materials.Delete'
  ])
  
  const isMaterialsAdmin = () => hasAnyPermission([
    'Supplier.Materials'
  ]) || hasAllPermissions([
    'Supplier.Materials.Create',
    'Supplier.Materials.Edit',
    'Supplier.Materials.Delete'
  ])
  
  return {
    // Individual permissions
    canViewMaterials,
    canCreateMaterials,
    canEditMaterials,
    canDeleteMaterials,
    
    // Combined permissions
    canAccessMaterials,
    canManageMaterials,
    isMaterialsAdmin,
    
    // Direct access to base permission functions
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }
} 